import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useTeamMembersDelete from 'hooks/useTeamMembersDelete';
import { useModalContext } from 'components/system/ModalContext';
import withNotification from 'components/hoc/withNotification';
import useAccountStore from 'store/accountStore';
import colors from 'styles/colors';
import TeamMemberRemovalConfirmation from './TeamMemberRemovalConfirmation';

const TeamSettingsRowActionMenu = ({
  id, name, updateTeamMembers, showSuccessNotification, showErrorNotification,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { mutate: removeMember } = useTeamMembersDelete(
    id, name, updateTeamMembers, showSuccessNotification, showErrorNotification,
  );
  const accountId = useAccountStore((state) => state.account.userId);

  const { openModal, closeModal } = useModalContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = async () => {
    setAnchorEl(null);
    await removeMember();
  };

  const handleDialogClose = () => {
    setAnchorEl(null);
    closeModal();
  };

  const handleRemove = () => {
    openModal({
      content: (
        <TeamMemberRemovalConfirmation
          onCancel={handleDialogClose}
          onClose={handleDialogClose}
          onConfirm={handleDelete}
          memberName={name}
        />
      ),
    });
  };

  return (
    <div>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        sx={{ color: colors.text.primary, paddingTop: 0, paddingBottom: 0 }}
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ fontSize: '20px' }} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button',
          sx: { padding: '10px 20px 10px 5px !important', background: colors.background.paper_11p },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={id === accountId ? () => {} : handleRemove}
          disabled={id === accountId}
        >
          Remove
        </MenuItem>
      </Menu>
    </div>
  );
};

export default withNotification(TeamSettingsRowActionMenu);
